import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { authOnIdentity } from '../../containers/Login/utils';

import { getIsLogged, getIdToken } from './selectors';
import userManager from '../../utils/userManager';

const HeaderLogin = ({ t }) => {
  const isLogged = useSelector(getIsLogged);
  const idToken = useSelector(getIdToken);
  const dispatch = useDispatch();
  const history = useHistory();
  const [waitingOAuth, setWaitingAuth] = useState(0);

  const login = () => {
    setWaitingAuth(true);
    authOnIdentity(dispatch, history);
  };

  const logout = () => {
    setWaitingAuth(true);
    userManager.signoutRedirect({ id_token_hint: idToken });
  };

  return <div className='login-container'>
    {
      !isLogged ? <button className={'btn' + (waitingOAuth ? ' disabled' : '')} onClick={login} disabled={waitingOAuth}>
        {t('headerLogin.login')}
      </button> : <button className={'btn' + (waitingOAuth ? ' disabled' : '')} onClick={logout}>
        {t('headerLogin.logout')}
      </button>
    }
  </div>;
};

HeaderLogin.propTypes = {
  t: PropTypes.func
};

export default HeaderLogin;
